import ApiClient from "../ApiClient";

const ZohoMeetingServices = {
  async getConnectionStatus() {
    const resp = await ApiClient.get("/Zoho/oauth/status");
    return resp.data.data;
  },

  async createWebinar(payload) {
    return ApiClient.post("/Zoho/create-webinar", payload).then((r) => r.data.data);
  },

  async createEventMeeting(payload) {
    return ApiClient.post("/Zoho/create-meeting", payload).then((r) => r.data.data);
  },
};

export default ZohoMeetingServices;
